var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useLazyAPI } from './useApi';
import { COMMON_API } from '../constants/routes';
export var usePostEvent = function () {
    var _a = useLazyAPI(), makeFetch = _a[0], data = _a[1];
    var postEvent = useCallback(function (eventName, context) {
        return makeFetch({
            endpoint: COMMON_API.events,
            params: {
                method: 'POST',
                body: JSON.stringify({
                    data: { event_name: eventName, event_context: __assign({}, context) },
                }),
                headers: {
                    'Content-type': 'application/json;charset=UTF-8',
                },
            },
        });
    }, [makeFetch]);
    return [postEvent, data];
};
